import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';
import SolutionSteps from 'components/SolutionSteps/SolutionSteps';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';

const SolutionBlockchainPage = ({ path }) => (
  <>
    <Meta
      title="Blockchain Solutions Providers | ATC Digital Business Solutions"
      description="Blockchain's capabilities to scale, stay secure, and match the needs of businesses, make it the go-to technology for the most demanding applications."
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/blockchain-banner.jpg"
          title="Blockchain Development. Evolve your Platform."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            When the future calls only the forward thinkers answer. Blockchain
            is the most forward leading change that your enterprise can employ.
            Curious? Let’s talk.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Redefine your Enterprise Future
                </h2>
                <p className="white-txt">
                  The future is now, and Blockchain is a leading technology that
                  employs the advancements that your enterprise needs. It’s
                  capabilities to scale, stay secure and yet match the needs of
                  business, make it the go to technology for the most demanding
                  applications. Put our experience and understanding to work for
                  you, we will help you navigate this game-changing technology.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="blockchainDevelopment"
          flyText="Blockchain Development"
          flyBoxImage="solutions/blockchain-box.jpg"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Blockchain: The Future is Verified
                </h2>
                <p>
                  Blockchain is an umbrella term for a variety of proven
                  technologies that, combined, provide a data structure that
                  makes it possible to create a distributed peer-to-peer system
                  of ledgers containing immutable (write-once and read-only)
                  time-stamped and connected blocks of data, which is operated
                  and updated. Blockchain has the potential to transform nearly
                  all industries, particularly those that rely on centralized
                  systems.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    Built for the
                    <br />
                    Future
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Discovery</h3>
                        <p>We listen to you.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Design</h3>
                        <p>Future-proof design.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Implementation</h3>
                        <p>Day 1 dependability.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Support</h3>
                        <p>Committed to your success.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionBlockchainPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionBlockchainPage;
